import { localize } from 'pseudo-localization';
import { MessageResource as CoreMessageResource } from '@medable/i18n-core';
import { Locale } from '@medable/i18n-core-v4';
const TOKEN_START = '\uE000';
const TOKEN_END = '\uE001';
const PROTECTED_PART_PATTERN = /(<[^>]+>|\uE000\d+\uE001)/g;
const PROTECTED_PART_EXACT_PATTERN = /^(<[^>]+>|\uE000\d+\uE001)$/;
export class MessageResource {
    constructor(locale, data) {
        this.messageResource = new CoreMessageResource(locale, data);
        this.pseudo = new Locale(locale).isPseudoLocale;
    }
    resolve(messageOrMessageArgs, resolveArgs = {}) {
        if (!this.pseudo) {
            return this.messageResource.resolve(messageOrMessageArgs, resolveArgs);
        }
        const { protectedArgs, tokens } = protectResolveArgs(resolveArgs);
        const resolvedMessage = this.messageResource.resolve(messageOrMessageArgs, protectedArgs);
        return `[${restoreTokens(pseudolocalizeMessage(resolvedMessage), tokens)}]`;
    }
}
function protectResolveArgs(resolveArgs) {
    const tokens = {};
    const protectedArgs = Object.entries(resolveArgs).reduce((args, [key, value], index) => {
        if (typeof value === 'string') {
            const token = `${TOKEN_START}${index}${TOKEN_END}`;
            tokens[token] = value;
            return Object.assign(Object.assign({}, args), { [key]: token });
        }
        return Object.assign(Object.assign({}, args), { [key]: value });
    }, {});
    return { protectedArgs, tokens };
}
function pseudolocalizeMessage(message) {
    return message
        .split(PROTECTED_PART_PATTERN)
        .map((part) => {
        if (!part || PROTECTED_PART_EXACT_PATTERN.test(part)) {
            return part;
        }
        return localize(part, { strategy: 'accented' });
    })
        .join('');
}
function restoreTokens(message, tokens) {
    return Object.entries(tokens).reduce((result, [token, value]) => result.split(token).join(value), message);
}
//# sourceMappingURL=message_resource.js.map